import Image from 'next/image'
import Link from 'next/link'

const CareerTestQuickItem = () => {
  return (
    <Link href={'/career-test'} as={'/career-test'} className="space-y-1.5">
      <div className="relative flex w-full flex-col items-center justify-center">
        <Image
          alt="IT_직무_유형_LION"
          className="rounded-2xl"
          src="https://d35ai18pny966l.cloudfront.net/career_test/career_banner_lion.png"
          width={42}
          height={42}
        />
      </div>
      <p className="text-center text-sm font-medium text-[#1E1E1E]">
        직무 유형
        <br />
        테스트
      </p>
    </Link>
  )
}

export default CareerTestQuickItem
